export function createEmptyBranch() {
  return {
    title: "סניף חדש",
    branch: "סניף חדש",
    address: "",
    time: "",
    waze: "",
    map: "",
    image: "../pic/logoround.png",
  };
}
